export const HOST = process.env.REACT_APP_HOST_API;
export const VERSION = 'api/v1/';

const APP_URL = {
    BUSCARCERTIFICADOS: `${HOST}${VERSION}web/form/buscarCertificados`,
}

export default APP_URL
